import { deferredPromise } from "../../utils/deferred-promise";
import Service from "../service";
class AlmaCmpService extends Service {
    constructor(config, context) {
        super("AlmaCmp", context);
        this.cmpReleased = false;
        this.requestsQueue = [];
        this.configuration = config;
    }
    // Eslint false positive
    // eslint-disable-next-line consistent-return
    wrapInternalApi(getter, callback) {
        if (typeof callback === "function") {
            try {
                const c = getter();
                callback(c);
            }
            catch (e) {
                this.logger.logWarn(`Consent is not set: ${e}`);
                callback({ error: "consent not set" });
            }
        }
        else {
            if (!this.cmpReleased) {
                this.logger.logInfo(`Consent is not ready yet, queueing request`);
                const p = deferredPromise(getter);
                this.requestsQueue.push(p);
                return p;
            }
            return new Promise((resolve, reject) => {
                try {
                    const consents = getter();
                    resolve(consents);
                }
                catch (e) {
                    this.logger.logError(`Unable to get consent from Gravito global: ${e}`);
                    reject(new Error("consent not set"));
                }
            });
        }
    }
}
export default AlmaCmpService;
//# sourceMappingURL=almacmp.js.map